<script lang="ts">
  import { invalidate } from '$app/navigation';
  import { updateClass } from '$lib/api/classes';
  import type { ClinicalGroupSummary } from '$lib/api/types';
  import ClassEditor from '$lib/components/classes/ClassEditor.svelte';
  import ClinicalGroupEditor from '$lib/components/classes/ClinicalGroupEditor.svelte';
  import Loading from '$lib/components/Loading.svelte';
  import TableMessage from '$lib/components/TableMessage.svelte';
  import type { PageProps } from './$types';
  let { params, data }: PageProps = $props();
  let editingClinicalGroup: ClinicalGroupSummary | null = $state(null);
  let newClinicalGroup = $state(false);
  let classId = $derived(parseInt(params.id));
</script>

{#await data.classPromise then clazz}
  <ClassEditor
    classInfo={clazz}
    onSave={async updated => {
      await updateClass(clazz.id, updated);
      invalidate(url => url.pathname.startsWith('/api/classes'));
    }}
  />
{/await}

{#await data.clinicalGroupsPromise}
  <Loading>Loading clinical groups...</Loading>
{:then clinicalGroups}
  <table class="table table-borderless table-hover mt-5">
    <thead>
      <tr class="border-bottom">
        <th scope="col"
          >Clinical Group <button
            class="btn btn-link py-0"
            onclick={() => {
              newClinicalGroup = true;
            }}>Add new</button
          ></th
        >
        <th scope="col">Instructor</th>
        <th scope="col" class="text-end">Students</th>
      </tr>
    </thead>
    <tbody>
      {#each clinicalGroups as grp (grp.id)}
        <tr
          onclick={() => {
            editingClinicalGroup = grp;
          }}
        >
          <td>{grp.name}</td>
          <td>
            {#if grp.instructorFirstName === undefined || grp.instructorLastName === undefined}
              <span class="text-secondary fst-italic">No Instructor Assigned</span>
            {:else}
              {grp.instructorFirstName} {grp.instructorLastName}
            {/if}
          </td>
          <td class="text-end">{grp.studentCount}</td>
        </tr>
      {/each}
    </tbody>
  </table>

  {#if clinicalGroups.length === 0}
    <TableMessage message="No clinical groups" />
  {/if}
{/await}

{#if editingClinicalGroup || newClinicalGroup}
  <ClinicalGroupEditor
    {classId}
    clinicalGroup={editingClinicalGroup}
    onClose={() => {
      newClinicalGroup = false;
      editingClinicalGroup = null;
    }}
  />
{/if}

<style>
  .table > tbody > tr > * {
    cursor: pointer;
  }
</style>
